import { styles } from './template.scss';
import { styles as flexboxHelpersStyles } from '../../assets/flexbox-helpers.scss';
import { styles as widgetSharedStyles } from '../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../assets/color-helpers.scss';
import { styles as styleHelpers } from '../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { styles as commonStyles } from '../../assets/common.scss';

export const templatePhasrApplyActionPanel = document.createElement('template');

templatePhasrApplyActionPanel.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='content-wrapper'>
      <div class='form-wrapper'>
      <gz-collapsable-container id='description-container'>
        <div id='description-text'></div>
      </gz-collapsable-container>
      <gz-labeled-content id="targeted-activity-type" hasColon labelfontsize="14"></gz-labeled-content>
      <gz-labeled-content id='rule-info' hasColon labelfontsize="14"></gz-labeled-content>
      <gz-labeled-content id='rule-triggers' hasColon labelfontsize="14"></gz-labeled-content>
      <gz-labeled-content id="attack-surface-reduction" hasColon labelfontsize="14"></gz-labeled-content>
      <gz-phasr-behavioral-profiles-restrict></gz-phasr-behavioral-profiles-restrict>
      </div>
      <div class='bottom-buttons'>
        <gz-button id='apply-button'></gz-button>
        <div class='flex-auto'></div>
        <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
      </div>
    </div>
  </div>
`;
